module.exports = __webpack_public_path__ + "img/priceImg-3.b949734d.png";